// extracted by mini-css-extract-plugin
export var errorIcon = "_o0-1";
export var nameLogo = "_o0-0";